import { getAllScenarioIds } from 'owa-day-grid-core-schema';
import { refreshDayGrid } from '../actions/privateActions';
import { orchestrator } from 'satcheljs';
import {
    calendarEventsAdded,
    calendarEventsRemoved,
    calendarEventUpdated,
} from 'owa-calendar-events-store';

export const calendarEventsAddedOrchestrator = orchestrator(
    calendarEventsAdded,
    refreshUncontrolledGrids
);
export const calendarEventsRemovedOrchestrator = orchestrator(
    calendarEventsRemoved,
    refreshUncontrolledGrids
);
export const calendarEventUpdatedOrchestrator = orchestrator(
    calendarEventUpdated,
    refreshUncontrolledGrids
);

function refreshUncontrolledGrids() {
    getAllScenarioIds().forEach(scenarioId => {
        refreshDayGrid(scenarioId);
    });
}
